<template>
  <div>
    <div class="row border-bottom">
      <div class="col-md-1 col"></div>
      <div class="col-md-10 col text-center">
        <p class="global-activity-title pb-10 m-0">{{ headerTitle }}</p>
      </div>
      <div class="col-md-1 col"></div>
    </div>
    <div id="profile" class="user-info" v-if="configFields">
      <form v-if="!isChangeEmail" id="profile-tab" class="profile-info">
        <div class="form-group" v-if="pwebCognitoAuthentication">
          <label v-translate:label_username="lang">Username</label>
          <input
            disabled
            type="text"
            name="username"
            class="form-control input-lg disabled-bg"
            placeholder="Username1"
            v-model="participant.cognitoUsername"
            :class="{
              input: true,
              'is-danger': errors.has('username'),
              'is-success': !errors.has('username')
            }"
            v-validate="getFieldObject('userName') && getFieldObject('userName').isOptional == 'required' ? 'required' : ''"
          />
          <span v-show="errors.has('username')" class="error-style" v-translate:error_mandatory_field="lang">Mandatory field</span>
        </div>
        <div class="form-group" v-if="getFieldObject('firstName') && getFieldObject('firstName').isVisible">
          <label v-translate:CONSENT_NAME_GIVEN="lang">First Name</label>
          <input
            type="text"
            class="form-control input-lg"
            v-translate:type_firstname.placeholder="lang"
            placeholder="Type your first name"
            onkeypress="return /[a-zA-Z\s]/i.test(event.key)"
            v-model="participant.participantMeta.firstName"
            name="fname"
            :class="{
              input: true,
              'is-danger': errors.has('fname'),
              'is-success': !errors.has('fname')
            }"
            v-validate="getFieldObject('firstName').isOptional == 'required' ? 'required' : ''"
          />
          <span v-show="errors.has('fname')" class="error-style" v-translate:error_mandatory_field="lang">Mandatory field</span>
        </div>
        <div class="form-group" v-if="getFieldObject('lastName') && getFieldObject('lastName').isVisible">
          <label v-translate:CONSENT_NAME_FAMILY="lang">Last Name</label>
          <input
            type="text"
            class="form-control input-lg"
            v-translate:type_lastname.placeholder="lang"
            placeholder="Type your last name"
            onkeypress="return /[a-zA-Z\s]/i.test(event.key)"
            v-model="participant.participantMeta.lastName"
            name="lname"
            :class="{
              input: true,
              'is-danger': errors.has('lname'),
              'is-success': !errors.has('lname')
            }"
            v-validate="getFieldObject('lastName') && getFieldObject('lastName').isOptional == 'required' ? 'required' : ''"
          />
          <span v-show="errors.has('lname')" class="error-style" v-translate:error_mandatory_field="lang">Mandatory field</span>
        </div>

        <div class="form-group" v-if="isFieldPartOfTokens('birthDate')">
          <input
            type="date"
            :max="maxDate"
            class="form-control input-lg"
            v-model="participant.participantMeta.dob"
            name="dob"
            onblur="if(!this.value)this.type='text'"
            onfocus="(this.type='date')"
            :class="{
              'input-class': true,
              'is-danger': errors.has('dob'),
              'is-success': !errors.has('dob'),
            }"
            required
            v-validate="
              getFieldObject('birthDate') &&
              getFieldObject('birthDate').isOptional === 'required'
                ? 'required'
                : ''
            "
          />
          <label v-translate:birth_date="lang" v-translate:birthdate_key="lang">Birth date</label>
          <span
            v-if="errors.has('dob')"
            class="error-style"
            v-translate:error_mandatory_field="lang"
          >
            Mandatory field
          </span>
        </div>

        <div
          class="form-group edit-email-arrow"
          v-if="!storeParticipant.verificationMethod || storeParticipant.verificationMethod != 'phone'"
        >
          <label v-translate:rsb_email="lang">Email</label>
          <input
            disabled
            type="email"
            name="email"
            class="form-control input-lg disabled-bg"
            v-translate:EMAIL_PLACEHOLDER.placeholder="lang"
            placeholder="Email"
            v-model="participant.email"
            :class="{
              input: true,
              'is-danger': errors.has('email'),
              'is-success': !errors.has('email')
            }"
            v-validate="getFieldObject('email') && getFieldObject('email').isOptional == 'required' ? 'required' : ''"
          />
          <div v-if="pwebCognitoAuthentication" class="info-email-edit-arrow" @click="onEmailChange">
            <i class="fa fa-angle-right fs-29"></i>
          </div>
          <span v-show="errors.has('email')" class="error-style" v-translate:error_mandatory_field="lang">Mandatory field</span>
        </div>
        <!-- TUR 61129 -->
        <div class="phone-number-wrap information-phone-wrap" v-else>
          <vue-tel-input
            class="mb-0 mr-0"
            wrapperClasses="vue-tel-macho-style"
            :dropdownOptions="{ showDialCodeInSelection: true }"
            mode="national"
            validCharactersOnly
            enabledCountryCode
            type="tel-input"
            :value="storeParticipant.mobileCountryCode + '' + storeParticipant.mobile"
            disabledFetchingCountry
            name="phoneNumber"
            ref="verificationPhoneInput"
            :defaultCountry="storeParticipant.mobileCountryCode"
            v-vue-tel-label="widget.translate('verification_phone_number_mobile', 'Verification Phone Number (Mobile)')"
            disabled
          >
          </vue-tel-input>
        </div>
        <!-- END OF 61129 -->
        <div class="form-group" v-if="configFields[7] && configFields[7].key == 'language' && configFields[7].isVisible">
          <label v-translate:participant_primary_lang="lang">Primary language</label>
          <input
            type="text"
            class="form-control input-lg"
            v-translate:participant_primary_lang.placeholder="lang"
            v-model="participant.participantMeta.language"
            onkeypress="return /[a-zA-Z\s]/i.test(event.key)"
            name="language"
            :class="{
              input: true,
              'is-danger': errors.has('language'),
              'is-success': !errors.has('language')
            }"
            v-validate="configFields[7].isOptional == 'required' ? 'required' : ''"
          />
          <span v-show="errors.has('language')" class="error-style" v-translate:error_mandatory_field="lang">Mandatory field</span>
        </div>
        <div class="form-group" v-if="configFields[8] && configFields[8].key == 'gender' && configFields[8].isVisible">
          <label v-translate:label_gender="lang">Gender</label>
          <select
            class="form-control type_select option-width"
            :class="{
              input: true,
              'is-danger': hasFieldError,
              'is-success': !hasFieldError
            }"
            @change="onGenderSelected(participant.participantMeta.gender)"
            v-validate="configFields[8].isOptional == 'required' ? 'required' : ''"
            v-model="participant.participantMeta.gender"
          >
            <option v-for="gender in configFields[8].expectedValues" :value="gender" :key="gender" :hidden="gender === otherGender">{{ gender }}</option>
          </select>
          <span class="error-style" v-translate:error_mandatory_field="lang" v-if="hasFieldError">Mandatory field</span>
        </div>
        <div class="form-group" v-if="getFieldObject('country') && getFieldObject('country').isVisible">
          <input
            type="text"
            class="form-control input-lg"
            v-translate:type_country.placeholder="lang"
            onkeypress="return /[a-zA-Z\s]/i.test(event.key)"
            v-model="participant.participantMeta.country"
            name="country"
            :class="{
              input: true,
              'is-danger': errors.has('country'),
              'is-success': !errors.has('country')
            }"
            required
            v-validate="getFieldObject('country').isOptional == 'required' ? 'required' : ''"
          />
          <label v-translate:country="lang">{{ getFieldObject("country").field }}</label>
          <span v-show="errors.has('country')" class="error-style" v-translate:error_mandatory_field="lang">Mandatory field</span>
        </div>

        <!-- Custom fields start -->
        <div v-if="customRegistrationFields">
          <div v-for="customField in customRegistrationFields" :key="customField.key">
            <div>
              <div class="form-group" v-if="getFieldObject(customField.key) && getFieldObject(customField.key).isVisible">
                <input
                  type="text"
                  class="form-control input-lg"
                  v-model="participant.participantMeta[customField.key]"
                  :name="getFieldObject(customField.key).key"
                  :class="{
                    input: true,
                    'is-danger': errors.has(customField.key),
                    'is-success': !errors.has(customField.key)
                  }"
                  required
                  v-validate="getFieldObject(customField.key) && getFieldObject(customField.key).isOptional == 'required' ? 'required' : ''"
                />
                <label>{{ customField.field }}</label>
                <span v-show="errors.has(customField.key)" class="error-style" v-translate:error_mandatory_field="lang">Mandatory field</span>
              </div>
            </div>
          </div>
        </div>
        <h5 class="mb-35" v-translate:label_contact_details="lang" v-if="isDtTokenContainsContactFields() || (getFieldObject('phoneNumber') && getFieldObject('phoneNumber').isVisible)">
          Contact Information
        </h5>
        <div class="form-group" v-if="isFieldPartOfTokens('address')">
          <input
            type="text"
            class="form-control input-lg"
            v-translate:participant_address.placeholder=" lang "
            placeholder="Type your address"
            v-model=" participant.participantMeta.address "
            name="address"
            :class="{ input: true, 'is-danger': errors.has('address'), 'is-success': !errors.has('address')}"
            required
            v-validate="getFieldObject('address') && getFieldObject('address').isOptional == 'required' ? 'required' : ''"
          />
          <label v-translate:participant_address="lang">Address</label>
          <span
            v-show=" errors.has('address') "
            class="error-style"
            v-translate:error_mandatory_field=" lang "
            >Mandatory field</span
          >
        </div>

        <div class="form-group" v-if="isFieldPartOfTokens('zipCode')">
            <input
                type="number"
                class="form-control input-lg"
                v-translate:participant_zip_postal.placeholder=" lang "
                placeholder="Type your Zip/Postal Code"
                v-model=" participant.participantMeta.zipcode "
                @keypress=" numberOnly "
                name="zipcode"
                :class="{input: true,'is-danger': errors.has('zipCode'),'is-success': !errors.has('zipCode')}"
                required
                v-validate="getFieldObject('zipCode').isOptional == 'required'? 'required': ''"
              />
              <label v-translate:participant_zip_postal=" lang "
                >Zip/Postal Code</label
              >
              <span
                v-show=" errors.has('zipcode') "
                class="error-style"
                v-translate:error_mandatory_field=" lang "
                >Mandatory field</span
              >
        </div>

        <div
          class="phone-number-wrap information-phone-wrap _bottom"
          v-if="getFieldObject('phoneNumber') && getFieldObject('phoneNumber').isVisible"
        >
          <vue-tel-input class="mb-0 mr-0 "
            ref="phoneNumber"
            wrapperClasses="vue-tel-macho-style input-filled"
            @onInput="onInputPhoneNumber"
            @country-changed="countryChanged"
            @validate="phoneValidated"
            :dropdownOptions="{ showDialCodeInSelection: true }"
            mode="national"
            validCharactersOnly
            enabledCountryCode
            type="tel-input"
            :value="contactPhone"
            name="phoneNumber"
            :preferredCountries="[participant.smsCountryIsoName]"
            :defaultCountry="participant.smsCountryIsoName"
            v-vue-tel-label.capitalize="widget.translate('label_enter_phone_number', 'Enter your phone number')"
            :class="{
              input: true,
              'is-danger': errors.has('phoneNumber'),
              'is-success': !errors.has('phoneNumber')
            }"
          >
          </vue-tel-input>
          <span v-if="participant.participantMeta.phoneNumber && participant.participantMeta.phoneNumber.length > 0 && !validTelNumber" class="error-style phone-error-style" v-translate:label_enter_valid_phone="lang">Please enter a valid phone number.</span>
          <span v-if="getFieldObject('phoneNumber').isOptional == 'required' && participant.participantMeta.phoneNumber == ''" class="error-style phone-error-style" v-translate:error_mandatory_field="lang">
            Phone number is required.
          </span>
          <span v-show="errors.has('mobile')" class="error-style" v-translate:error_mandatory_field="lang">{{ errors.first("mobile") }}</span>
        </div>
        <div class="text-right mt-48 mb-33">
          <button class="btn btn-submit primary-bg" v-translate:rsb_submit="lang" data-toggle="modal" data-target="#ConfirmEmailModal" data-dismiss="modal" v-on:click.prevent="updateParticipant">
            Submit
          </button>
        </div>
      </form>
      <form v-if="isChangeEmail" id="profile-tab" class="profile-info">
        <div class="form-group" v-if="getFieldObject('email') && getFieldObject('email').isVisible">
          <label v-translate:rsb_email="lang">Email</label>
          <input
            disabled
            type="email"
            name="email"
            class="form-control input-lg disabled-bg"
            v-translate:EMAIL_PLACEHOLDER.placeholder="lang"
            placeholder="Email"
            v-model="participant.email"
            :class="{
              input: true,
              'is-danger': errors.has('email'),
              'is-success': !errors.has('email')
            }"
          />
        </div>
        <div class="form-group edit-email-arrow">
          <label v-translate:label_email_change="lang">Change Email</label>
          <input
            type="newEmailAddress"
            name="newEmailAddress"
            class="form-control input-lg disabled-bg"
            v-translate:enter_new_email="lang"
            placeholder="Enter new email"
            v-validate="'required|email'"
            v-model="newEmailAddress"
            :class="{
              input: true,
              'is-danger': errors.has('newEmailAddress'),
              'is-success': !errors.has('newEmailAddress')
            }"
          />
          <div v-if="emailError" class="text-danger">{{ emailError }}</div>
        </div>
        <div class="text-right mt-48 mb-33 ">
          <button class="btn btn-submit secondary-bg" v-translate:text_signin_button="lang" data-toggle="modal" data-target="#ConfirmEmailModal" data-dismiss="modal" v-on:click.prevent="openModal" :disabled="!newEmailAddress || errors.has('newEmailAddress') || emailError != null">
            Next
          </button>
        </div>
      </form>
    </div>
    <b-modal :hide-header="true" :hide-footer="true" size="lg" :body-class="['p-0']" class="export-activity-success-modal" @hide="onCloseModel" scrollable :no-close-on-backdrop="true" style="width: 538px;" v-model="confirmEmail">
      <div class="partipant-registration-modal__container">
        <img src="static/img/add.svg" class="close-icon ml-auto pr-16 pt-16 cursor-pointer" style="float: right;" @click="onCloseModel" />
        <div class="confirmEmailTitle" v-translate:label_email_verification="lang">
          Email Verification
        </div>
        <div class="verification text-center">
          <p class="mb-0 email-msg" v-translate:verify_email="lang">
            Verification email was sent to
          </p>
          <label class="email-id">{{ newEmailAddress }}</label>
          <p class="paricipant-reg-name primary-text" style="color: var(--primary)!important" v-if="participant">
            {{ participantFullName }}
          </p>
          <p class="email-text" v-translate:verify_email_message="lang">
            If you have not received the verification email within a few minutes, please check your Spam or Junk folder.
          </p>
          <p class="email-text1 cursor-pointer" data-dismiss="modal" @click="onCloseModel" v-translate:label_change_email_address="lang">
            Change email address
          </p>
          <p class="email-text1 cursor-pointer" @click="onEditEmailAddress" v-translate:label_resend_email="lang">
            Resend verification email
          </p>
          <p class="email-text2" v-translate:pw_email_verify="lang">
            Once verified, click below.
          </p>
        </div>
        <button class="btn confirmEmailBtn" @click="submitEmail" data-dismiss="modal" style="background-color: var(--primary)!important" v-translate:label_continue="lang">
          Continue
        </button>
        <div v-if="showLoader">
          <loader v-if="showLoader"></loader>
          <vue-progress-bar class="progress_bar_header"></vue-progress-bar>
        </div>
      </div>
    </b-modal>
    <!-- Confirm Email Modal Start -->
    <!-- Modal for gender -->
    <b-modal size="lg" :hide-header="true" :hide-footer="true" :body-class="['p-0']" class="export-activity-success-modal d-header-none" @hide="onCloseModel" scrollable :no-close-on-backdrop="true" style="width: 538px;" v-model="isOtherGender">
      <!-- v-model='confirmEmail' -->
      <div class="participant-gender-modal">
        <img src="static/img/add.svg" class="close-icon ml-auto pr-16 pt-16" style="float: right;" @click="onCloseGenderModel" />
        <div class="text-center p-48">
          <div class="form-group pt-80">
            <input type="text" required="required" v-model="otherGender" class="form-control" placeholder="Enter gender preference" />
            <!-- <label v-translate:ENTER_GENDER_PREFERENCE="lang">Enter gender preference</label> -->
          </div>

          <div class="text-center pt-45 pb-48">
            <button class="btn btn-submit" @click="onCloseGenderModel" v-translate:PREFER_NOT_TO_SAY_TEXT="lang">
              I prefer not to say
            </button>
            <button class="btn btn-submit primary-bg mt-25" :disabled="otherGender === ''" style="background-color: var(--primary)!important" @click="onGenderChange" v-translate:rsb_done="lang">
              Done
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Bitrise, Widget, DatavantTokens, ParticipantPortal } from "@/components/services/participant-service";
import swal from "sweetalert2";
import loader from "@/components/common/loader";
import $ from "jquery";
import moment from "moment";

export default {
  name: "information",
  components: { loader },
  data() {
    return {
      pid: "",
      bitrise: new Bitrise(),
      configFields: [],
      globalElement: null,
      hasFieldError: false,
      participant: {},
      howDidYouHear: ["Facebook", "Twitter", "Snapchat", "Other Social Media", "Blog", "Google Search", "Apple App Store", "Google Play Store"],
      widget: new Widget(),
      confirmEmail: false,
      validTelNumber: false,
      isChangeEmail: false,
      showLoader: false,
      newEmailAddress: "",
      emailError: null,
      headerTitle: "",
      isOtherGender: false,
      otherGender: "",
      coreGenders:[],
      phoneObject:null,
      contactPhone:null,
      isDatavantTokenizationEnabled: false,
      datavantTokens : new DatavantTokens(),
      datavantTokenFields : null,
      portal: new ParticipantPortal(),
    };
  },
  async mounted() {   
    this.participant = JSON.parse(JSON.stringify(this.storeParticipant));
    await this.checkIfDatavantTokenizationEnabled();
    this.headerTitle = this.widget.translate('personal_info','Personal Information')
    this.getFormConfig(); 
    this.otherGender = this.participant.participantMeta.gender;
    this.contactPhone = this.$options.filters.e164(this.participant.participantMeta.phoneNumber, this.participant.participantMeta.countryCode);
    this.validTelNumber = true;
    
  },
  computed: {
    ...mapGetters({
      storeParticipant: "participant",
      token: "token",
      pwebCognitoAuthentication: "pwebCognitoAuthentication"
    }),
    participantFullName() {
      if (this.participant) {
        const fullName = (this.participant.participantMeta && this.participant.participantMeta.firstName) + " " + (this.participant.participantMeta && this.participant.participantMeta.lastName);
        return fullName;
      }
      return "";
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    customRegistrationFields() {
      return this.configFields.filter(it => it.type == "customfields").sort((a, b) => a.index - b.index);
    }
  },
  watch: {
    storeParticipant: {
      handler() {
        this.getFormConfig();
        this.participant = JSON.parse(JSON.stringify(this.storeParticipant));
        this.validTelNumber = true;
      }
    },
    newEmailAddress: {
      handler() {
        if (this.errors.has("newEmailAddress")) {
          this.emailError = this.widget.translate("label_please_enter_valid_email_address", "Please enter a valid email address.");
        } else if (this.newEmailAddress == this.participant.email) {
          this.emailError = this.widget.translate("label_please_enter_new_email_address", "Please enter a new email address.");
        } else {
          this.emailError = null;
        }
      }
    }
  },
  methods: {
    ...mapActions(["participantLogout"]),
    onEmailChange() {
      this.isChangeEmail = true;
      this.newEmailAddress = "";
      this.headerTitle = this.widget.translate("rsb_change_email", "Change Email");
    },
    onCloseModel() {
      this.confirmEmail = false;
    },
    openModal() {
      this.onEditEmailAddress();
      this.confirmEmail = true;
    },
    onCloseGenderModel() {
      if (this.coreGenders.length === 0) {
        this.coreGenders = this.getFieldObject("gender").expectedValues;
      }
      this.otherGender = "";
      this.getFieldObject("gender").expectedValues = this.coreGenders;
      this.participant.participantMeta.gender = "Other gender identity";
      this.isOtherGender = false;
    },
    onGenderChange() {
      if (this.coreGenders.length === 0) {
        this.coreGenders = this.getFieldObject("gender").expectedValues;
      }
      const isExist = this.getFieldObject("gender").expectedValues.indexOf(this.otherGender) > -1;
      if (this.otherGender !== "" && !isExist) {
        this.getFieldObject("gender").expectedValues = [...this.coreGenders, this.otherGender];
        this.participant.participantMeta.gender = this.otherGender;
      } else {
        this.getFieldObject("gender").expectedValues = this.coreGenders;
      }
      this.isOtherGender = false;
    },
    onGenderSelected(value) {
      this.otherGender = "";
      if (value == "Other gender identity") {
        this.isOtherGender = true;
      } else {
        this.onGenderChange();
      }
    },
    countryChanged(phoneObject) {
      if (phoneObject) {
        this.phoneValidated(this.phoneObject);
      }
    },
    phoneValidated(phoneObject) {
      this.phoneObject = phoneObject;
      this.validTelNumber = phoneObject ? phoneObject.valid : false;
      if (this.getFieldObject("phoneNumber").isOptional !== "required") {
        this.validTelNumber = true;
      }
    },
    phoneOnValidate(el1) {
      if (!this.$refs || !this.$refs[el1] || !this.$refs[el1].$el) {
        return;
      }
      const vuetel = this.$refs[el1].$el;
      const input = $(vuetel).find("input");
      if (input.val().length > 0 && input.val().charAt(0) == "0") {
        input.val(input.val().substring(1));
      }
    },
    onInputPhoneNumber(phoneObject) {
      this.phoneObject = phoneObject;
      const { number, isValid, country } = phoneObject;
      const { dialCode } = country;
      this.participant.participantMeta.phoneNumber = number.significant;
      this.participant.participantMeta.countryCode = "+" + dialCode;
      this.validTelNumber = isValid;
      if (this.getFieldObject("phoneNumber").isOptional !== "required" && number.input == "") {
        this.validTelNumber = true;
      }
    },
    logout() {
      this.$store.dispatch("participantLogout");
    },
    getFormConfig() {
      const registrationDataObj = this.bitrise.getJsonData("study_participantregistrationconfiguration");
      if (registrationDataObj) {
        registrationDataObj
          .then(response => {
            this.configFields = response.participantRegistrationConfigDetails;
            if(response.dataVantTokens){
              this.datavantTokenFields = response.dataVantTokens;
            }
            if (this.getFieldObject("gender").isVisible) {
              this.onGenderChange();
            }
            if (this.getFieldObject("phoneNumber").isVisible) {
              this.phoneOnValidate("phoneNumber");
            }
            if (this.getFieldObject("verificationPhone").isVisible) {
              this.phoneOnValidate("verificationPhoneInput");
            }
          })
          .catch(e => {
            const message = this.widget.translate(e.message, "Data sync failed, please try again after some time.");
            if (message) {
              this.$toastr.error(message);
            }
          });
      }
    },
    getFieldObject(key) {
      const object = this.configFields.find(o => o.key === key);
      return object || null;
    },
    onEditEmailAddress() {
      this.showLoader = true;
      const { cognitoUsername, languageId, studyId } = this.participant;
      const emailPayload = {
        cognitoUsername: cognitoUsername,
        deviceType: "web",
        email: this.newEmailAddress,
        language: languageId,
        pid: this.participant.pid,
        studyId: studyId
      };
      this.$api
        .editEmailOnCognito(this.participant.pid, languageId, emailPayload)
        .then(() => {
          this.showLoader = false;
        })
        .catch(err => {
          const message = this.widget.translate(err.message, "Error!");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    submitEmail() {
      this.$api
        .checkEmailVerified(this.participant.pid)
        .then(res => {
          const isVerifyEmail = res.body;
          this.getProfileInformation();
          if (isVerifyEmail.emailVerified) {
            $("#ConfirmEmailModal").modal({ backdrop: true });
            this.confirmEmail = false;
            const message = this.widget.translate("label_profile_updated", "Profile updated successfully.");
            this.$toastr.success(message);
            setTimeout(() => {
              this.isChangeEmail = false;
              this.headerTitle = this.widget.translate("profile_information", "Profile Information");
            }, 80);
          } else {
            swal({
              title: this.widget.translate("label_check_email_validate", "Please check your email inbox to validate your new email address."),
              type: "warning",
              showCancelButton: false,
              cancelButtonColor: "var(--primary)!important",
              cancelButtonText: "Ok"
            }).then(() => {});
          }
        })
        .catch(err => {
          const message = this.widget.translate(err.message, "Internal Server Error");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    getProfileInformation() {
      this.$api
        .getParticipantsProfileDetails(this.participant.pid)
        .then(response => {
          const participant = response.data;
          this.$store.dispatch("participantUpdate", participant);
        })
        .catch(e => {
          const message = this.widget.translate(e.message, "Problem in fetching profile details.");
          this.$toastr.error(message);
        });
    },
    updateParticipant() {
      if (this.participant.gender === "Other gender identity" && this.otherGender != "") {
        this.participant.gender = this.otherGender;
      }
      this.$validator.validateAll().then(valid => {
        if (valid && this.validTelNumber) {
          if (this.phoneObject) {
            this.participant.participantMeta.phoneNumber = this.phoneObject.number.significant;
            this.participant.participantMeta.countryCode = "+" + this.phoneObject.country.dialCode;
          }
          this.hasFieldError = false;
          for (const key in this.participant.participantMeta) {
            if (this.participant.participantMeta[key] == null && (key == "dobMonth" || key == "dobYear" || key == "dobDay" || key == "genderIdentifier" || key == "ageRangeIdentifier")) {
              delete this.participant.participantMeta[key];
            }
          }

          //Prepare datavant token Only if Datavant tokenization is enabled & country is US
          let defaultCountryISOC = this.portal.getDefaultCountryIso2();
          if (this.isDatavantTokenizationEnabled && defaultCountryISOC != "" && defaultCountryISOC.toLowerCase() == "us") {
            this.participant.datavantToken = this.datavantTokens.prepareTokensMeta(this.participant, this.datavantTokenFields);
          }
          this.participant.participantMeta.dob = this.participant && this.participant.participantMeta && this.participant.participantMeta.dob ? moment(this.participant.participantMeta.dob).format("YYYY-MM-DD") : "";
          this.$api.updateParticipantDataFact(this.participant.pid, this.participant).then(() => {
            this.$store.dispatch("participantUpdate", this.participant);
            const message = this.widget.translate("label_profile_updated", "Profile updated successfully.");
            this.$toastr.success(message);
            setTimeout(() => {
              this.$router.push({ name: "participants-portal-profile" });
            }, 90);
          });
        }
      });
    },
    numberOnly(evt) {
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 96 || charCode > 105)
      ) {
        evt.preventDefault();
      }
    },
    maxDate() {
      var now = new Date();
      return now.toISOString().substring(0, 10);
    },
    async checkIfDatavantTokenizationEnabled() {
        await this.$api.getDatavantWebToggleState({ studyId: this.participant.studyId, featureKey : "DatavantTokenization" })
            .then(res => {
                this.isDatavantTokenizationEnabled = res.body && res.body[0] && res.body[0].enabled ? true : false;
            })
            .catch(err => {
                let message = this.widget.translate(
                    err.message,
                    "Error while fetching the study features details!"
                );
                if (message) {
                    this.$toastr.error(message);
                }
            });
    },
    isDtTokenContainsContactFields(){
      if(!this.isDatavantTokenizationEnabled){
        return false;
      }
      
      if(this.datavantTokens.checkIfFieldPresentInTokens('address', this.datavantTokenFields)){
        return true;
      }

      //In Token zipCode has various forms so we are just using zip
      if(this.datavantTokens.checkIfFieldPresentInTokens('zip', this.datavantTokenFields)){
        return true;
      }

      return false;
    },
    isFieldPartOfTokens(participantField){
      if(!this.isDatavantTokenizationEnabled){
        return false;
      }

      let tokenString = _.clone(participantField);
      if(participantField == 'zipCode'){
        tokenString = 'zip';
      }
      else if(participantField == 'birthDate'){
        tokenString = 'dob';
      }

      if(this.getFieldObject(participantField) && this.getFieldObject(participantField).isVisible && this.datavantTokens.checkIfFieldPresentInTokens(tokenString, this.datavantTokenFields)){
        return true;
      }

      return false;
    }
  },
};
</script>

<style scoped lang="scss">
.error-style {
  position: absolute;
  font-size: 12px;
  top: 53px;
  color: #ff4848;
  padding-bottom: 5px;
}
#profile-tab .form-group {
  position: relative;
  margin: 30px 0 !important;
}
.email-text1 {
  font-family: RobotoRegular;
  font-size: 16px;
  line-height: 1.31;
  letter-spacing: -0.32px;
  color: #4c6473;
}
.email-text2 {
  margin: 48px 121px 13px 121px;
  font-family: RobotoRegular;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.08px;
  color: #9b9b9b;
}
.email-id {
  font-family: Robotolight;
  font-size: 28px;
  font-weight: 300;
  color: #4a4a4a;
  padding: 0;
  padding: 0 48px;
  word-break: break-all;
}
.email-text {
  margin: 13px 20px 48px 20px;
  font-family: RobotoRegular;
  font-size: 13px;
  line-height: 1.38;
  letter-spacing: -0.08px;
  color: #9b9b9b;
}
#profile-tab .form-group label {
  font-size: 12px;
  position: absolute;
  top: -15px;
  left: 17px;
  padding: 5px;
  background-color: white;
}
.phone-error-style {
  left: 205px;
}
.d-header-none .modal-header,
.d-header-none .modal-footer {
  display: none !important;
}
.participant-gender-modal .form-control {
  font-size: 18px !important;
}
.participant-gender-modal .form-control::placeholder {
  text-align: center;
}
.information-phone-wrap {
  margin-bottom: 10px;
  position: relative;
}
.information-phone-wrap .phone-error-style {
  left: 135px;
  top: 100%;
}
</style>
